export const TOGGLE_SEARCH_PANEL = '[SEARCH PANEL] TOGGLE SEARCH PANEL';

export function toggleSearchPanel(value = null)
{
    return {
        type   : TOGGLE_SEARCH_PANEL,
        payload: value,
    }
}